import React, { useRef } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { CaretRight, CaretLeft } from "@phosphor-icons/react";
import Container from "Components/Container/Container";

const Gallery = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <section className="map  py-10">
      <Container className="relative h-full">
        <div className=" absolute z-[1000] right-0 top-1/2 -translate-y-1/2 gap-x-2 mb-4">
          <button
            ref={prevRef}
            className="slider-arrow z-[100]  flex items-center justify-center bg-black text-3xl text-font p-2 border border-font "
          >
            <CaretLeft />
          </button>
          <button
            ref={nextRef}
            className="slider-arrow z-[100]  flex items-center justify-center bg-black text-3xl text-font p-2 border border-font "
          >
            <CaretRight />
          </button>
        </div>

        <Swiper
          spaceBetween={10}
          slidesPerView={1}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            992: {
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
          }}
          modules={[Autoplay, Navigation]}
          className="w-full"
          speed={1000}
        >
          {data?.map((image, index) => (
            <SwiperSlide key={index} className="w-full   flex justify-center">
              <div className="w-full flex items-center justify-center h-full ">
                <img
                  alt=""
                  className="w-full max-h-[800px] object-csover"
                  src={image}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default Gallery;
